import { render, staticRenderFns } from "./EventAdminV.vue?vue&type=template&id=3d42fb96"
import script from "./EventAdminV.vue?vue&type=script&lang=js"
export * from "./EventAdminV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports